<template>
  <template v-if="!$root.isPopup">
    <!-- App -->
    <template v-for="device in $root?.devices?.online" :key="device">
      <template v-if="device?.loaded === true">
        <Device_Info_Both :config="device.config" />
        <template v-if="device?.config?.infoType == 'full'">
          <Device_Info_Full
            :config="device.config"
            @click="focus(device)"
            @focus="focus(device)"
          />
        </template>
      </template>
    </template>
  </template>

  <template v-else>
    <!-- POPUP -->
    <!-- <pre style="height: 500px; overflow: scroll;">{{ $root?.devices?.online }}</pre> -->

    <template v-for="device in $root?.devices?.online" :key="device">
      <template
        v-if="device?.loaded === true && device?.config?.infoType == 'popup'"
      >
        <Device_Info_Popup :config="device.config" />
      </template>
    </template>
  </template>
</template>

<script>
import Device_Info_Full from "@/partials/Device/Info/Device_Info_Full.vue";
import Device_Info_Both from "@/partials/Device/Info/Device_Info_Both.vue";
import Device_Info_Popup from "@/partials/Device/Info/Device_Info_Popup.vue";

export default {
  name: "Device_Windows_Full",
  components: {
    Device_Info_Full,
    Device_Info_Both,
    Device_Info_Popup,
  },

  methods: {
    focus(device) {
      if (device.config?.full_screen_active == true) return;

      for (let key in $root.devices.online) {
        let _device = $root.devices.online[key];

        if (_device.config?.full_screen_active == true) {
          _device.config.full_screen_active = false;
        }
      }

      device.config.full_screen_active = true;
    },
  },
};
</script>
